<app-channel-player
  class="channel-player"
  [class.no-background]="platformType === HTVPlatform.PHILIPS"></app-channel-player>
<ng-container *ngIf="channel">
  <div id="channel-overlay" class="channel-overlay opacity-transition">
    <div class="channel-overlay__actions">
      <app-tracks-menu-v1 [channel]="channel"></app-tracks-menu-v1>
      <span class="gap-separator"></span>
      <button
        class="channel-overlay__actions__exit-button htv-selectable htv-focus"
        [class.no-pointer]="platformType === HTVPlatform.PHILIPS"
        (click)="openChannelGrid()"
        tabindex="-1">
        <img src="assets/images/icons/zoom_in_map.svg" alt="zoom-in" />
      </button>
    </div>
    <div class="channel-overlay__channel-data">
      <div class="channel-overlay__logo">
        <img [src]="channel.logoUrl" alt="Channel Logo" />
      </div>
      <span class="channel-overlay__separator"></span>
      <div class="channel-overlay__current-program">
        <div class="channel-overlay__current-program__progress">
          <app-channel-progress [channel]="channel"></app-channel-progress>
        </div>
        <div class="mat-title-medium text-ellipsis">{{ channel.id }} - {{ channel.name }}</div>
        <div class="mat-title-medium text-ellipsis">
          {{ (channel.liveEPG$ | async)?.currentProgram?.title | titlecase }}
        </div>
        <div class="channel-overlay__current-program__summary mat-body-medium">
          {{ (channel.liveEPG$ | async)?.currentProgram?.description }}
        </div>
      </div>
      <ng-container *ngIf="(channel.liveEPG$ | async)?.nextProgram">
        <span class="channel-overlay__separator"></span>
        <div class="channel-overlay__next-program">
          <div class="mat-title-medium text-ellipsis">
            {{ 'PAGES.CHANNEL.NEXT_PROGRAM' | translate }}
          </div>
          <div class="mat-title-small text-ellipsis">
            {{ (channel.liveEPG$ | async)?.nextProgram?.start | momentp }}
            {{ (channel.liveEPG$ | async)?.nextProgram?.title }}
          </div>
        </div>
      </ng-container>
      <span class="channel-overlay__separator"></span>
      <div class="channel-overlay__time">
        <app-time size="large"></app-time>
      </div>
    </div>
  </div>
</ng-container>
